import React, { Fragment } from 'react'

import { connect } from 'react-redux'

import { Load_Level_List, get_Level_Action_Id } from '../../../../Store/Actions/Setting.Action'

import CoTable from '../../../Containers/Table'
import GenericModals from '../../../Containers/GenericModals'

import Add from './Modal/Level/Add'
import View from './Modal/Level/View'
import Delete from './Modal/Level/Delete'

class SettingLevel extends React.Component {
    componentDidMount() {
        this.props.Load_Level_List()
    }
    onClickActionId(Id) {
        this.props.get_Level_Action_Id(Id)
    }
    render() {
        const LevelList = this.props.LevelList
        const HeadData = [
            {
                Nama: 'No',
                width: '5%',
            },
            {
                Nama: 'Id',
                width: '15%',
            },
            {
                Nama: 'Nama',
                width: '30%',
            },
            {
                Nama: 'Deskripsi',
                width: '30%',
            },
            {
                Nama: 'View',
                width: '10%',
            },
            {
                Nama: 'Delete',
                width: '10%',
            },
        ]
        const BodyData = LevelList ? LevelList.map((item, index) => {
            return {
                index: index + 1,
                Id: item.Id,
                Name: item.Nama,
                Deskripsi: item.Deskripsi,
                View: (
                    <GenericModals
                        size='xl'
                        header='View Level'
                        body={<View />}
                        Buttoncolor='primary'
                        ButtononClickeven={() => this.onClickActionId(item.Id)}
                        Buttonlabel={'view'}
                    />
                ),
                Delete: (
                    <GenericModals
                        size='m'
                        header='Delete Form'
                        body={<Delete />}
                        Buttoncolor='error'
                        ButtononClickeven={() => this.onClickActionId(item.Id)}
                        Buttonlabel={'Delete'}
                    />
                )
            }
        }) : []
        const isLevelLoading = this.props.isLevelLoading
        return (
            <Fragment>
                <h2>
                    Level Setting
                </h2>

                <center>
                    <GenericModals
                        size='m'
                        header='Tambah Level'
                        body={<Add />}
                        Buttoncolor='primary'
                        Buttonstyle={{ width: '90%' }}
                        ButtononClickeven={() => null}
                        Buttonlabel={'+ Level'}
                    />
                </center>

                <CoTable
                    TableId='LevelSetting'
                    HeadData={HeadData}
                    isHeadLoading={HeadData ? false : true}
                    Data={BodyData}
                    isBodyLoading={isLevelLoading}
                />
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    isLevelLoading: state.Setting.isLevelLoading,
    LevelList: state.Setting.LevelList,
})

export default connect(mapStateToProps, { Load_Level_List, get_Level_Action_Id })(SettingLevel)
